
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-safe/create",
      function () {
        return require("private-next-pages/new-safe/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-safe/create"])
      });
    }
  